import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// Firebase Auth imports needed for login logic
import { auth, functions } from '../firebase'; // Ensure 'functions' is exported from your firebase.js
import { signInWithEmailAndPassword } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions'; // Import for calling cloud functions

function Home() {
  // Login State & Logic
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false); // For login button state
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    setIsLoggingIn(true); // Indicate login process started

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user) {
        // Check for custom claims and call addClaimCreds if necessary
        const idTokenResult = await user.getIdTokenResult();
        const claims = idTokenResult.claims;

        const orgId = claims.orgId;
        const userMid = claims.userMid;
        const userFid = claims.userFid;

        // Check if any of the crucial claims are missing (undefined, null, or empty string)
        const claimsAreMissing = !orgId || !userMid || !userFid;

        if (claimsAreMissing) {
          setError('Finalizing account setup...'); // Inform user of a brief delay

          try {
            const addClaimCredsFn = httpsCallable(functions, 'addClaimCreds');
            const functionResult = await addClaimCredsFn();

            // Force a token refresh to pick up any new claims
            console.log('Home.js: Forcing ID token refresh...');
            await user.getIdToken(true); // Pass true to force refresh
            console.log('Home.js: ID token refreshed.');
            setError(''); // Clear "Finalizing" message
          } catch (claimError) {
            console.error('Home.js: Error calling addClaimCreds or refreshing token:', claimError);
            // Set a non-blocking error, as login was successful but claim update might have failed.
            // The application should ideally handle missing claims gracefully elsewhere too.
            setError('Login successful, but an issue occurred updating account details. Please try refreshing if you encounter issues.');
            // We still proceed to navigate, as the user is logged in.
            // A more robust solution might involve a dedicated loading/setup screen.
          }
        }
      }
      navigate('/dashboard');

    } catch (err) {
      console.error("Login Error:", err);
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
           setError('Invalid email or password.');
      } else if (err.code === 'auth/invalid-email') {
          setError('Please enter a valid email address.');
      } else {
           setError('Failed to log in. Please try again.');
      }
    } finally {
        setIsLoggingIn(false); // Reset login process indicator
    }
  };

  return (
    <div>
      {/* Carousel Section with Login Overlay */}
      <div id="myCarousel" className="carousel slide position-relative" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="first-slide d-block w-100" src="/assets/modern.JPG" alt="First slide" style={{ minHeight: '400px', objectFit: 'cover' }} />
            <div className="container h-100">
              <div className="row h-100">
                {/* Caption Column */}
                <div className="col-lg-7 col-md-6 d-flex align-items-end">
                  {/* Desktop Caption: Remains hidden on mobile as per original d-none d-md-block */}
                  <div className="carousel-caption text-left text-white d-none d-md-block" style={{ position: 'static', paddingBottom: '3rem', textAlign: 'left' }}>
                    <h1 className="display-4">A church directory for this century</h1>
                    <p className="lead">Access your member information when you need it most - directly from the cloud.</p>
                  </div>
                </div>

                {/* Login Form Column Overlay
                    CHANGED: Removed d-none d-md-block, added responsive column widths for mobile
                */}
                <div
                  className="col-11 col-sm-9 col-md-5 col-lg-4 position-absolute end-0 top-0 p-3 p-lg-4"
                  style={{ zIndex: 10 }}
                >
                   <div className="card shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)'}}>
                      <div className="card-body p-4">
                        <h3 className="card-title text-center mb-4">Sign In</h3>
                        {error && <div className={`alert ${error.includes('Finalizing') ? 'alert-info' : 'alert-danger'} py-2`} role="alert">{error}</div>}
                        <form onSubmit={handleLogin}>
                          {/* Email Input */}
                          <div className="mb-3">
                            <label htmlFor="emailLogin" className="form-label">Email</label>
                            <input type="email" className="form-control" id="emailLogin" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={isLoggingIn} />
                          </div>
                          {/* Password Input */}
                          <div className="mb-3">
                            <label htmlFor="passwordLogin" className="form-label">Password</label>
                            <input type="password" className="form-control" id="passwordLogin" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={isLoggingIn} />
                          </div>
                          {/* Login Button */}
                          <div className="d-grid mt-4">
                              <button type="submit" className="btn btn-primary" disabled={isLoggingIn}>
                                {isLoggingIn ? 'Logging In...' : 'Login'}
                              </button>
                          </div>
                        </form>
                        {/* Forgot Password Link */}
                        <div className="text-center mt-3">
                          <Link to="/forgot-password" style={{ fontSize: '0.9em' }}>Forgot Password?</Link>
                        </div>
                        <hr className='my-3'/>
                         {/* Member Signup Area within Login Card */}
                         <div className="text-center">
                            <p className='mb-2' style={{ fontSize: '0.9em' }}>Need a personal account?</p>
                             <Link
                                to="/create-account"
                                className="btn btn-sm btn-success w-100" /* Green button */
                             >
                                Join your existing church directory {/* Updated text */}
                             </Link>
                         </div>
                      </div> {/* End card-body */}
                   </div> {/* End card */}
                </div> {/* End Login Column */}
              </div> {/* End row */}
            </div> {/* End container */}
          </div> {/* End carousel-item */}
        </div> {/* End carousel-inner */}
      </div> {/* End Carousel */}


      {/* Marketing Section */}
      <div className="container marketing" style={{ marginTop: '50px' }}>
            {/* ... Icons: Easy, Affordable, Secure ... */}
            <div className="row text-center"> <div className="col-lg-4"> <img className="rounded-circle" src="/assets/easy.jpg" alt="Easy to use" width="140" height="140" /> <h1 className="mt-3 h2">Easy to use</h1> <h4>Designed and built by church communication experts.</h4> </div> <div className="col-lg-4"> <img className="rounded-circle" src="/assets/money.jpg" alt="Affordable" width="140" height="140" /> <h1 className="mt-3 h2">Affordable</h1> <h4>Pricing designed to fit in any budget.</h4> </div> <div className="col-lg-4"> <img className="rounded-circle" src="/assets/lock.jpg" alt="Secure" width="140" height="140" /> <h1 className="mt-3 h2">Secure</h1> <h4>Only individuals in your directory have access.</h4> </div> </div>
           <hr className="featurette-divider" style={{ margin: '3rem 0' }} />
           {/* Featurette 1 */}
           <div className="row featurette align-items-center"> <div className="col-md-7"> <h2>Every member has a login</h2> <p className="lead">Anyone whose email address is listed in your church's directory can create their own free user account to access the directory.</p> <h2>Members maintain their data</h2> <p className="lead">User accounts allow members to update their family's information in your directory, increasing accuracy.</p> </div> <div className="col-md-5"> <img className="rounded img-fluid" src="/assets/computer.jpg" alt="Computer screen showing directory" /> </div> </div>
           <hr className="featurette-divider" style={{ margin: '3rem 0' }} />
            {/* Feature Cards Grid */}
           <div className="container"> <h2 className="text-center mb-4">Feature Highlights</h2> <div className="row row-cols-1 row-cols-md-3 g-4"> {/* Cards 1-6 */} <div className="col"><div className="card h-100 shadow-sm"><div className="card-header text-center text-white" style={{ backgroundColor: '#2174ce' }}>Member Information</div><img className="card-img-top" src="/assets/List_1.jpg" alt="Member Information" /></div></div> <div className="col"><div className="card h-100 shadow-sm"><div className="card-header text-center text-white" style={{ backgroundColor: '#2174ce' }}>Family View</div><img className="card-img-top" src="/assets/Grid_1.jpg" alt="Family View" /></div></div> <div className="col"><div className="card h-100 shadow-sm"><div className="card-header text-center text-white" style={{ backgroundColor: '#2174ce' }}>Member Maps</div><img className="card-img-top" src="/assets/map.png" alt="Member Maps" /></div></div> <div className="col"><div className="card h-100 shadow-sm"><div className="card-header text-center text-white" style={{ backgroundColor: '#2174ce' }}>Create Bible Studies</div><img className="card-img-top" src="/assets/BibleStudies_1.jpg" alt="Create Bible Studies" /></div></div> <div className="col"><div className="card h-100 shadow-sm"><div className="card-header text-center text-white" style={{ backgroundColor: '#2174ce' }}>Mobile App</div><img className="card-img-top" src="/assets/App_1.jpg" alt="Mobile App" /></div></div> <div className="col"><div className="card h-100 shadow-sm"><div className="card-header text-center text-white" style={{ backgroundColor: '#2174ce' }}>Member Groups</div><img className="card-img-top" src="/assets/Groups_1.jpg" alt="Member Groups" /></div></div> </div> </div>
           <hr className="featurette-divider" style={{ margin: '3rem 0' }} />

           {/* Pricing/Features Section - UPDATED */}
           <div className="container pb-5">
             <div className="row justify-content-center">
               <div className="col-lg-8 col-md-10">
                   <div className="card mb-4 rounded-3 shadow-sm">
                   <div className="card-header py-3 text-white" style={{ backgroundColor: '#28a745' }}>
                       <h4 className="my-0 fw-normal">Account Features</h4>
                   </div>
                   <div className="card-body">
                       <ul className="list-unstyled mt-3 mb-4 text-center"> {/* Added text-center */}
                         {/* Assuming FontAwesome is set up globally or using <i> tags */}
                          <li><i className="fas fa-dollar-sign me-2"></i>1 Year Free Trial - Then $10 / Month</li>
                          <li><i className="fas fa-user me-2"></i>Unlimited Free Church Member Accounts</li>
                          <li><i className="fas fa-user-tie me-2"></i>Unlimited Admin Users</li>
                          <li><i className="far fa-file-pdf me-2"></i>Printable PDF Directory</li>
                          <li><i className="fas fa-bible me-2"></i>Create and Share Bible Studies</li>
                          <li><i className="fas fa-mobile-alt me-2"></i><a href="https://play.google.com/store/apps/details?id=com.churchaware.churchaware">Android</a> and <a href="https://apps.apple.com/us/app/church-aware/id1422942877?ls=1">iOS</a> Apps</li>
                       </ul>
                       <div className="text-center">
                           {/* *** UPDATED Admin Text Styling *** */}
                           <p className="fw-semibold mb-2"> {/* Removed small, text-muted; added fw-semibold, mb-2 */}
                               For Church Administrators setting up a new directory:
                           </p>
                           <Link to="/register-organization" className="w-75 btn btn-lg btn-success">
                               Register Your Church
                           </Link>
                       </div>
                   </div>
                   </div>
               </div>
             </div>
           </div>

      </div> {/* End marketing container */}
    </div> // End wrapper div
  );
}

export default Home;